/**
 * Centralized address data for locations used across the application
 * This includes both English and Arabic names with corresponding Google Maps URLs
 */

export interface Address {
  name: string;
  url: string;
}

/****************
 * Emmanuel House
 ****************/
export const EMMANUEL_HOUSE_LOCATION_URL = "https://www.google.com/maps/place/%D8%A8%D9%8A%D8%AA+%D8%B9%D9%85%D8%A7%D9%86%D9%88%D8%A6%D9%8A%D9%84%E2%80%AD/@30.0605572,31.2538046,17z/data=!4m6!3m5!1s0x145841ae3da88f17:0x4f5dee131636614c!8m2!3d30.0605573!4d31.2489391!16s%2Fg%2F11fqxh50v9?entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoASAFQAw%3D%3D";
export const EMMANUEL_HOUSE_EN: Address = {
  name: "Emmanuel House",
  url: EMMANUEL_HOUSE_LOCATION_URL
};
export const EMMANUEL_HOUSE_AR: Address = {
  name: "بيت عمانوئيل",
  url: EMMANUEL_HOUSE_LOCATION_URL
};
/****************
 * Kasr El-Dobara
 ****************/
export const KASR_EL_DOBARA_LOCATION_URL = "https://www.google.com/maps/place/%D8%A7%D9%84%D9%83%D9%86%D9%8A%D8%B3%D8%A9+%D8%A7%D9%84%D8%A5%D9%86%D8%AC%D9%8A%D9%84%D9%8A%D8%A9+%D8%A8%D9%82%D8%B5%D8%B1+%D8%A7%D9%84%D8%AF%D9%88%D8%A8%D8%A7%D8%B1%D8%A9%E2%80%AD/@30.0420466,31.2372822,17z/data=!3m1!4b1!4m6!3m5!1s0x145840b799f70327:0xc8e835dec378ae2f!8m2!3d30.0420466!4d31.2347126!16s%2Fg%2F121_5crf?entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoASAFQAw%3D%3D";
export const KASR_EL_DOBARA_EN: Address = {
  name: "Kasr El-Dobara",
  url: KASR_EL_DOBARA_LOCATION_URL
};
export const KASR_EL_DOBARA_AR: Address = {
  name: "قصر الد,بارة",
  url: KASR_EL_DOBARA_LOCATION_URL
};

/****************
 * Agape House
 ****************/
export const AGAPE_HOUSE_LOCATION_URL = "https://maps.app.goo.gl/bGwxspiBzGmbE7KY6";
export const AGAPE_HOUSE_EN: Address = {
  name: "Agape House",
  url: AGAPE_HOUSE_LOCATION_URL
};
export const AGAPE_HOUSE_AR: Address = {
  name: "بيت أغابي",
  url: AGAPE_HOUSE_LOCATION_URL
};


/****************
 * To Be Determined
 ****************/
export const ADDRESS_TBD_EN: Address = {
  name: "To be determined",
  url: ""
};

export const ADDRESS_TBD_AR: Address = {
  name: "سيتم تحديده لاحقًا",
  url: ""
};
